// import { $req } from "../utils";
import request from '../utils/request'
export default {
	/*-------------------------------------------------------------设备start-----------------------------------------------------------  */
	
	//采购-原辅料-价格填报查询接口-田海光
	rawMaterialPriceQuery({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/purchase/rawMaterialPrice/query`,
			data: params
		})
	},
	//采购-原辅料-价格填报保存/发布接口-田海光
	rawMaterialPriceSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/purchase/rawMaterialPrice/save`,
			data: params
		})
    },
   //采购-原辅料-采购预算填报查询接口-田海光
	queryDeviceBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/purchase/rawMaterialBudget/query`,
			data: params
		})
	},
	//采购-原辅料-采购预算填报保存和发布接口-田海光
	rawMaterialBudgetSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/purchase/rawMaterialBudget/save`,
			data: params
		})
	},
	//llt 测试菜单数据
	menumock({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/menumock`,
			data: params
		})
	},
	// 财务/原材料查询
	queryRawMaterial(params) {
		return request({
			method: 'POST',
			url: "/bpc/purchase/rawMaterialPrice/queryRawMaterial",
			data: params
		})
	},

	// 财务单价导入
	export(params) {
		return request({
			method: 'POST',
			url: "/bpc/purchase/rawMaterialPrice/export",
			data: params
		})
	},

	// 代理发货采购成本列表
	queryProcurementCostAgent(params) {
		return request({
			method: 'GET',
			url: `/bpc/purchase/procurementCostAgent/queryList?configurationId=`+params,
			data: params
		})
	},
	//代理发货采购成本保存/发布接口
	saveProcurementCostAgent({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/purchase/procurementCostAgent/update`,
			data: params
		})
    },
	
}